import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const OfficeLogo = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path d='M11.0625 2L2.0625 2.00001L2.06251 11H11.0625V2Z' fill={primaryColorToUse} />
      <path d='M11.0625 2L2.0625 2.00001L2.06251 11H11.0625V2Z' fill={primaryColorToUse} />
      <path d='M11.0625 13L2.0625 13L2.06251 22H11.0625V13Z' fill={primaryColorToUse} />
      <path d='M11.0625 13L2.0625 13L2.06251 22H11.0625V13Z' fill={primaryColorToUse} />
      <path d='M22.0625 2L13.0625 2.00001L13.0625 11H22.0625V2Z' fill={primaryColorToUse} />
      <path d='M22.0625 2L13.0625 2.00001L13.0625 11H22.0625V2Z' fill={primaryColorToUse} />
      <path d='M22.0625 13L13.0625 13L13.0625 22H22.0625V13Z' fill={primaryColorToUse} />
      <path d='M22.0625 13L13.0625 13L13.0625 22H22.0625V13Z' fill={primaryColorToUse} />
    </svg>
  );
};
